import { Navigate, Outlet } from "react-router-dom";
import { useUserProfile } from "@/hooks/useUserProfile";
import { useBakeryPartner } from "@/hooks/queries";

export function BakeryProtectedRoute() {
  const { session, profile, loading } = useUserProfile();
  const partnerQuery = useBakeryPartner();

  // Route-guard state machine, derived rather than state-managed. The
  // bakery-partner query only runs when useAuth() provides a session
  // with the bakery role, so `data` being null here means "no partner
  // row found" (not "loading"); the query's own isLoading covers the
  // fetch window.
  const partnerLoading = session?.user?.id ? partnerQuery.isLoading : false;
  const partner = partnerQuery.data;

  if (loading || partnerLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-navy border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/bakery-login" replace />;
  }

  if (profile?.role !== "bakery") {
    // Logged-in but not a bakery user, route them to their actual portal
    // instead of the bakery login page. Avoids the "I just got logged out"
    // illusion from audit #30.
    if (profile?.role === "lembra_admin") return <Navigate to="/admin" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  if (!partner) {
    // bakery role but no partner row, same non-bakery redirect as above.
    return <Navigate to="/dashboard" replace />;
  }

  if (!partner.is_active) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream px-6">
        <div className="max-w-md text-center">
          <h2 className="text-2xl font-bold text-navy mb-3">Account suspended</h2>
          <p className="text-charcoal/70 mb-6">
            Your vendor partner account has been temporarily suspended. Please contact support to resolve this.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
